export default __webpack_public_path__ + "static/media/Dickson Huang.870161b6.png";